var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormItem',{attrs:{"label":"收货地址","isError":_vm.isError,"isErrorBlink":_vm.isErrorBlink}},[_c('OrderAddress',_vm._b({ref:"orderAddressRef",on:{"change":_vm.handleChange}},'OrderAddress',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }